import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	enterFullScreen: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	exitFullScreen: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	fullScreenShortcut: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	fullScreenShortcutPlain: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	enterFullScreenShortcutNew: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	exitFullScreenShortcutNew: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	fullScreenShortcutNewPlain: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	enterFullScreen: {
		id: 'platform.fullscreen-button.enter-full-screen',
		defaultMessage: 'Enter full screen',
		description: 'Tooltip content for enter full screen button',
	},
	exitFullScreen: {
		id: 'platform.fullscreen-button.exit-full-screen',
		defaultMessage: 'Exit full screen',
		description: 'Tooltip content for exit full screen button',
	},
	fullScreenShortcut: {
		id: 'platform.fullscreen-button.full-screen-shortcut',
		defaultMessage: '<inline>Z</inline>',
		description: 'Shortcut for entering or exiting full screen mode',
	},
	fullScreenShortcutPlain: {
		id: 'platform.fullscreen-button.full-screen-shortcut-plain',
		defaultMessage: 'Z',
		description: 'Plain text shortcut for accessibility',
	},
	enterFullScreenShortcutNew: {
		id: 'platform.fullscreen-button.enter-full-screen-shortcut-new',
		defaultMessage: 'Enter full screen <inline>Shift</inline> + <inline>Z</inline>',
		description: 'Shift + Z shortcut for entering full screen mode',
	},
	exitFullScreenShortcutNew: {
		id: 'platform.fullscreen-button.exit-full-screen-shortcut-new',
		defaultMessage: 'Exit full screen <inline>Shift</inline> + <inline>Z</inline>',
		description: 'Shift + Z shortcut for exiting full screen mode',
	},
	fullScreenShortcutNewPlain: {
		id: 'platform.fullscreen-button.full-screen-shortcut-new-plain',
		defaultMessage: 'Shift + Z',
		description: 'Plain text Shift + Z shortcut for accessibility',
	},
});
export default messages;
